"use strict";

exports.statusesHash = {
  published: 'published',
  ready: 'ready',
  draft: 'draft',
  deleted: 'deleted'
};
exports.statusTitlesHash = {
  published: 'Опубликовано',
  ready: "\u0413\u043E\u0442\u043E\u0432\u043E \u043A\xA0\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438",
  draft: 'Черновик',
  deleted: 'Удалено'
};
exports.importEntityStatusesHash = {
  successful: 'successful',
  failed: 'failed'
};
exports.importEntityStatusTitlesHash = {
  successful: 'Успешно',
  failed: 'Ошибка'
};